import { Component, OnInit, Input, EventEmitter, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { departmentsOptionsConstant, currencyOptionsConstant, studyReportTypeConstant, studyReportSubTypeConstant, studyReportPatientConstant, documentOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { Subject } from 'rxjs';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { EditAndDeleteOperationsRenderer } from 'src/app/common/client-grid/edit-and-delete-operations.component';
import { GridApi } from 'ag-grid-community';
import { AttachmentClassificationComponent } from 'src/app/common/attachment-classification/attachment-classification.component';
import { DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { IstDataShareService } from '../../../../services/ist/ist-datashare.service';
import { MessageBoxComponent } from '../../../../common/message-box/message-box.component';
import { UserService } from '../../../../services/user.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import * as $ from 'jquery';
import { CommonService } from '../../../../services/common.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { EditOthersRenderer } from 'src/app/common/client-grid/edit-others-operations.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-ist-study-reports-view-modal',
  templateUrl: './ist-study-reports-view-modal.component.html',
  styleUrls: ['./ist-study-reports-view-modal.component.scss']
})
export class IstStudyReportsViewModalComponent implements OnInit {

  @Input() public Content: any;
  formFields;
  departments = departmentsOptionsConstant;
  currencyOptions = currencyOptionsConstant;
  studyReportsForm: UntypedFormGroup;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  formData: FormData;
  typeOptions: any[];
  subtypeOptions: any[];
  AllsubtypeOptions: any[];
  patientOptions: any[];
  documentOptions = documentOptionsConstant;
  gridApi: GridApi;
  rowData;
  context;
  ApplicationID: any;
  userType: string = "";
  operations: any[] = [];
  Attachments: any[] = [];
  RequiredSettings: boolean = true;
  selectedRow: any;
  loadGrid = false;
  gridOptions;
  columnDefs;
  frameworkComponents;
  AppStatus: any;
  staticformFields: any;

  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  TempOperations: { name: string; id: string; }[];

  constructor(
    private summaryService: IstSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    private datashareService: IstDataShareService,
    private userService: UserService,
    public commonService: CommonService

  ) { }

  getStaticFiledsData(screenCode: string) {
    this.commonService.getScreenStaticFields(screenCode)
      .subscribe(summary => {
        this.staticformFields = summary["Data"];
      });
  }

  ngOnInit() {
    this.getStaticFiledsData('SCR-009');
    this.rowData = [];
    this.AppStatus = this.commonService.getIstStatus();
    this.datashareService.ApplicationID.subscribe(x => {
      this.ApplicationID = x;
    });
    if (this.Content.heading === 'Add') { //Add mode
      this.Content.content.id = this.commonService.getUniqueId();
    }
    this.userType = this.userService.getUserType();
    this.studyReportsForm = new UntypedFormGroup({
      ID: new UntypedFormControl(""),
      APPLICATION_ID: new UntypedFormControl(""),
      TYPE: new UntypedFormControl(""),
      SUB_TYPE: new UntypedFormControl(""),
      PATIENT_ID: new UntypedFormControl(null),
      TITLE: new UntypedFormControl(""),
      NOTES: new UntypedFormControl(""),
      STATUS: new UntypedFormControl(0)
    });

    this.GetDropDownsData();

    this.columnDefs = [
      {
        "headerName": "Attachment Classification",
        "field": "AttachmentClassification"
      },
      {
        "headerName": "File Name",
        "field": "FileName"
      },
      {
        "headerName": "Date",
        "field": "Date"
      },
      {
        headerName: "",
        field: "value",
        cellRenderer: "editOthersRenderer",
        colId: "params",
        width: 50,
        sortable: false,
        cellStyle: { "overflow": 'visible' }
      }

    ];

    this.TempOperations = [];

    this.context = { id: this.Content.content.id, componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,
      }
    }

    this.disable();
  }

  GetDropDownsData() {
    this.summaryService.masterData("api/ISTStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=" + this.Content.content.id).subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
      this.typeOptions = [{ label: "Select", value: "", checked: true }].concat(this.typeOptions);
      this.AllsubtypeOptions = summary["MasterData2"];
      this.AllsubtypeOptions = [{ label: "Select", value: "", checked: true }].concat(this.AllsubtypeOptions);
      this.patientOptions = summary["MasterData3"];
      if (this.Content.heading === 'Edit' || this.Content.heading === 'View') { // Edit mode
        this.getRecordFprEdit();
        if (this.Content.heading === 'View') {
          this.studyReportsForm.disable();
        }
      }
    });
  }

  disable(){
    if(this.studyReportsForm.controls['TYPE'].value == null || this.studyReportsForm.controls['TYPE'].value == "" || this.studyReportsForm.controls['TYPE'].value == undefined){
      this.studyReportsForm.controls['SUB_TYPE'].disable();
    } else{
      if (this.Content.heading != 'View'){
        this.studyReportsForm.controls['SUB_TYPE'].enable();
      }
    }
  }

  CategoryChange(data1) {
    this.subtypeOptions = [];
    let data = this.AllsubtypeOptions?.filter(x => x.Parentvalue == data1);
    this.subtypeOptions = [{ label: "Select", value: "", checked: true }].concat(data);
    this.disable();
  }

  deleteRow() { }

  editRow() { }

  getRecordFprEdit() {
    this.summaryService.getScreenDataForEdit("api/ISTStudyreports/Edit?RecordID=" + this.Content.content.id).subscribe(result => {
      this.studyReportsForm.patchValue({
        ID: result["ID"],
        APPLICATION_ID: result["APPLICATION_ID"],
        TITLE: result["TITLE"],
        NOTES: result["NOTES"],
        TYPE: result["TYPE"],
        SUB_TYPE: result["SUB_TYPE"],
        PATIENT_ID: result["PATIENT_ID"],
        STATUS: result["STATUS"],
      });

      this.rowData = result["Attachments"];
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);

      this.CategoryChange(this.studyReportsForm.controls["TYPE"].value);

      if (this.studyReportsForm.controls["STATUS"].value == '2') { // Edit mode
        this.studyReportsForm.disable();
        this.Content.heading = "View";
      }

      this.extendedForm.rowid = result["ID"];
      this.extendedForm.getResponse();

    });
  }

  SaveStudyReports() {
    if (this.validateControls()) {

      var formData = this.studyReportsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["RECORD_STATE"] = 0;
      formData["CREATED_DATE"] = new Date();
      formData["LAST_UPDATED_DATE"] = new Date();
      let studyRpt = this.studyReportsForm.controls["TITLE"].value;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTStudyreports/Insert", formData).subscribe(result => {
          if (result.Status == 0) {
            this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) {
                this.commonService.SuccessBanner('Study report  ' + studyRpt + ' Added/Submitted successfully');
                this.modalRef.close();
              }
              else
              {
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTStudyreports/Update", formData).subscribe(result => {
          this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
          if (result.Status == 0 ||  result.ErrorCode == "NOCHANGES")
          {
          this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") {
                if (result.Status === 0) {
                  this.commonService.SuccessBanner('Study report  ' + studyRpt + ' details updated successfully');
                  this.modalRef.close();
                }
                else {
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else{
                if (result.ErrorCode === "NOCHANGES" && result1.ErrorCode === "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else{
                  this.commonService.SuccessBanner('Study report  ' + studyRpt + ' details updated successfully');
                    this.modalRef.close(formData);
                }
              }
          });
        }
        else
        {
          this.commonService.ValidationBanner(result.Message);
        }

          // if (result.Status == 0) {
          //   this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner('Study report  ' + studyRpt + ' details updated successfully');

          //     this.modalRef.close();
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //         this.commonService.ValidationBanner(result.Message);
          //       }
          //       else {
          //         this.commonService.SuccessBanner('Study report  ' + studyRpt + ' details updated successfully');
          //       //  this.action.next(formData);
          //         this.modalRef.close(formData);
          //       }
          //     }
          //   });
          // }



        });
      }
    }
  }

  validateControls(): boolean {
    let isValid = true;
    let message = "";
    const formData = this.studyReportsForm.value;

    if (this.staticformFields?.TYPE.IS_Display && this.staticformFields?.TYPE.IS_MANDATORY) {
      if (formData.TYPE === null || formData.TYPE === "") {
        $("#TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.TYPE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TYPE").addClass("ng-untouched ng-valid");
        $("#TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TYPE.IS_Display && this.staticformFields?.SUB_TYPE.IS_Display && this.staticformFields?.SUB_TYPE.IS_MANDATORY) {
      if (formData.SUB_TYPE === null || formData.SUB_TYPE === "") {
        $("#SUB_TYPE").addClass("ng-touched ng-invalid validate-error");
        $("#SUB_TYPE").removeClass("ng-untouched ng-valid");
        message += `Please select ${this.staticformFields?.SUB_TYPE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#SUB_TYPE").addClass("ng-untouched ng-valid");
        $("#SUB_TYPE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.TITLE.IS_Display && this.staticformFields?.TITLE.IS_MANDATORY) {
      if (formData.TITLE === null || formData.TITLE === "") {
        $("#TITLE").addClass("ng-touched ng-invalid validate-error");
        $("#TITLE").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.TITLE.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#TITLE").addClass("ng-untouched ng-valid");
        $("#TITLE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.NOTES.IS_Display && this.staticformFields?.NOTES.IS_MANDATORY) {
      if (formData.NOTES === null || formData.NOTES === "") {
        $("#NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#NOTES").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.NOTES.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#NOTES").addClass("ng-untouched ng-valid");
        $("#NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    let ExtenMsgs = this.extendedForm.validateControlsMsgs();
    if (ExtenMsgs != null && ExtenMsgs != undefined && ExtenMsgs.length > 0) {
      isValid = false;
      message = message + ExtenMsgs; //this.extendedForm.validateControlsMsgs();
    }

    if (!isValid)
      this.commonService.ValidationBanner(message);

    return isValid;
  }

  SubmitRecord() {
    if (this.validateControls()) {

      var formData = this.studyReportsForm.value;
      formData["APPLICATION_ID"] = this.ApplicationID;
      formData["RECORD_STATE"] = 0;
      formData["CREATED_DATE"] = new Date();
      formData["LAST_UPDATED_DATE"] = new Date();
      formData["STATUS"] = 2;
      let studyRpt = this.studyReportsForm.controls["TITLE"].value;
      this.rowData.forEach(element => {
        element["Operations"] = [];
      });
      formData["Attachments"] = this.rowData;
      if (this.Content.heading == "Add") {
        formData["ID"] = this.Content.content.id;
        this.summaryService.Insert("api/ISTStudyreports/Insert", formData).subscribe(result => {
          if (result.Status == 0) {
            this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.Status == 0) {
                this.commonService.SuccessBanner('Study report  ' + studyRpt + ' Added/Submitted successfully');
                this.modalRef.close();
              }
              else{
                this.commonService.ValidationBanner(result1.Message);
              }
            });
          }
          else{
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
      else {
        this.summaryService.Insert("api/ISTStudyreports/Update", formData).subscribe(result => {
          if (result.Status == 0 || result.ErrorCode == "NOCHANGES") {
            this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
            this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
              if (result1.ErrorCode == "NOCONTROLS") {
                if (result.Status == 0)
                {
                  this.commonService.SuccessBanner('Study report  ' + studyRpt + ' submitted successfully');
                  this.modalRef.close();
                }
                else{
                  this.commonService.ValidationBanner(result.Message);
                }
              }
              else{
                if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
                  this.commonService.ValidationBanner(result.Message);
                }
                else {
                  this.commonService.SuccessBanner('Study report  ' + studyRpt + ' submitted successfully');
                  this.modalRef.close(formData);
                }
              }

            });
          }
          else
          {
            this.commonService.ValidationBanner(result.Message);
          }

          // if (result.Status == 0) {
          //   this.studyReportsForm.controls["ID"].setValue(result.TransactionID);
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     this.commonService.SuccessBanner('Study report  ' + studyRpt + ' submitted successfully');

          //     this.modalRef.close();
          //   });
          // } else {
          //   this.extendedForm.saveControls(result.TransactionID, this.ApplicationID, result.TransactionCode).subscribe(result1 => {
          //     if (result1.ErrorCode == "NOCONTROLS" && result.ErrorCode == "NOCHANGES") {
          //       this.commonService.ValidationBanner(result.Message);
          //     }
          //     else {
          //       if (result1.ErrorCode == "NOCHANGES" && result.ErrorCode == "NOCHANGES") {
          //         this.commonService.ValidationBanner(result.Message);
          //       }
          //       else {
          //         this.commonService.SuccessBanner('Study report  ' + studyRpt + ' submitted successfully');
          //        // this.action.next(formData);
          //         this.modalRef.close(formData);
          //       }
          //     }
          //   });
          // }



        });
      }
    }
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  getAttachmentsData() {
    this.summaryService.getSummaryData("api/ISTFileAttachments/getScreenAttachments?TransactionID=" + 1).subscribe((result) => {
      this.rowData = result;
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 350);
    });


  }

  addNewAttachment() {
    let modalRef = this.modalService.open(AttachmentClassificationComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-md right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      screencode:"SCR-009",
      is_ac_display:this.staticformFields.StudyReport_AC.IS_Display,
      is_ac_mand:this.staticformFields.StudyReport_AC.IS_MANDATORY,
      ac_label:this.staticformFields.StudyReport_AC.LABEL_NAME,
      is_file_display:this.staticformFields.StudyReport_CF.IS_Display,
      is_file_mand:this.staticformFields.StudyReport_CF.IS_MANDATORY,
      file_lable:this.staticformFields.StudyReport_CF.LABEL_NAME,
      file_subLabel:this.staticformFields.StudyReport_CF.SUB_LABEL,
      is_multiple_files:this.staticformFields.StudyReport_CF.IS_MULTISELECT,
      content: { id: "", ModuleName: "IST", ScreenName: 'StudyReports' , filesList: this.rowData}
    }
    modalRef.result.then(result => {
      this.loadGrid = false;
      result.forEach((item: any) => {
        this.rowData.push(item);
      });
      this.setOperations(this.rowData);
      setTimeout(() => {
        this.loadGrid = true;
        document.body.click();
      }, 300);
    })

  }

  setOperations(RawData: any): any {
    let tempOperations;
    if (this.Content.heading == 'Edit') {
      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        },
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == 'View') {
      tempOperations = [
        {
          "name": "Download",
          "id": "Download"
        },
        {
          "name": "Preview",
          "id": "ViewFile"
        }
      ];
    }

    if (this.Content.heading == "Add") {

      tempOperations = [
        {
          "name": "Delete",
          "id": "Delete"
        }
      ];
    }

    this.setDef(tempOperations);
    RawData.forEach(element => {
      if (element.Status == "Add" && this.Content.heading == 'Edit') {
        this.TempOperations = [];
        this.TempOperations.push(
          {
            "name": "Delete",
            "id": "Delete"
          }
        );
        element["Operations"] = this.setDef(this.TempOperations);
      } else {
        element["Operations"] = this.setDef(tempOperations);
      }
    });
    return RawData;
  }

  setDef(parmoperations: any): any {

    this.operations = parmoperations.map(operation => {
      return operation &&
        (operation.id === "add" || operation.id === "view_modal")
        ? {
          name: operation.name,
          callback: this[operation.id],
          self: this,
          disabled: "false"
        }
        : { name: operation.name, callback: this[operation.id], self: this };
    });
    return this.operations;
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onOperationClick(opr) {
    opr.callback();
  }

  onGridReady(params) {
    this.gridApi = params.api;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
      this.gridApi.startEditingCell(params);
    }, 500);
  }

  Download() {
    var fileID = this['self'].selectedRow['FileID'];
    let Url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + fileID;
    window.open(Url);
  }

  ViewFile() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    this['self'].commonService.previewFile(fileID, fileName, "med");
  }

  Delete() {
    var fileID = this['self'].selectedRow['FileID'];
    var fileName = this['self'].selectedRow['FileName'];
    let modalRef = this["self"].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content= { heading: '', custommessage: 'Are you sure you want to delete the ' + fileName + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel"  };
    modalRef.result.then(result => {
      if (result == 'okclick') {
        let index = this['self'].rowData.findIndex(x => x.FileID == fileID);
        if (index != null) {
          this['self'].rowData.splice(index, 1);
          this['self'].loadGrid = false;
          setTimeout(() => {
            this['self'].loadGrid = true;
            document.body.click();
          }, 300);
        }
      }
    });
  }
}
